module.exports = {"330782001":"稠城街道","330782002":"江东街道","330782003":"稠江街道","330782004":"北苑街道","330782005":"后宅街道","330782006":"城西街道","330782007":"廿三里街道","330782008":"福田街道","330782100":"佛堂镇","330782101":"赤岸镇","330782102":"义亭镇","330782104":"上溪镇","330782105":"苏溪镇","330782106":"大陈镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330782.json
// module id = 924
// module chunks = 0